<template>
    <div name="ranking-banner" class="banner"> 
        
        <div class="inner">
            <img style="width: 731.5px;" src="../../../assets/ranking_banner.png"/>
            <div class="right-contents">
                <span class="title">1형 당뇨인 <span style="color: var(--Blue-01_Primary-blue, #008DEF);">불편접수함</span>
                    <img class="image" src="../../../assets/flight.png" />
                </span>
                <span class="description" style="margin-top: 16px;;">
                    1형 당뇨인과 가족들이 ‘불편함’을 느낀 순간을<br>
                    솔닥 컨시어지는 그냥 지나치지 않습니다.  <br><br>
                    지금 떠오르는 불편함이 있다면 알려주세요.<br>
                    <span style="font-weight: 700;">해결할 수 있는 방법을 함께 찾고,<br> 
                    행동으로 바꿔나가겠습니다.</span>
                </span>
                <div class="button" style="margin-top: 32px;" @click="postUncomfortable">
                    불편 접수하기 →
                </div>
                <span class="info-text" style="margin-top: 16px;">* 비속어나 권리 침해 게시물 방지를 위해<br>회원 로그인 후 작성이 가능합니다.</span>
                <div class="fixed-bar" v-if="isFixedBarView">
                    <span class="text2">📬 1형 당뇨인 불편접수함</span>
                    <span class="text3" style="margin-left: 32px;">불편한 점을 알려주시면 직접 행동으로 바꿔나가겠습니다.</span>
                    <div class="button2" style="margin-left: 58px;" @click="postUncomfortable">불편 접수하기 →</div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
// 불편 접수함 
// 끝에 닿았을때 전환 
export default {
    name: 'rankingBanner',
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    data: function()
    {
        return {
            isFixedBarView: false,
            scrollY: 0
        }
    },
    methods: {
        postUncomfortable: function()
        {
            this.$emit('postUncomfortable')
        },
        handleScroll() {
            this.scrollY = window.pageYOffset || document.documentElement.scrollTop;
            
            if(this.scrollY > 500)
            {
                this.isFixedBarView = true;
            }
            else
            {
                this.isFixedBarView = false
            }
        }
    }

}
</script>

<style scoped>
    .banner {
        width: 100%;
        height: 620px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: linear-gradient(to right, #C0D4ED 0%, #FFFFFF 100%);
         
    }
    .inner {
        width: 1296px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

    }
    .right-contents {
        width: 405px;
        margin-left: 41px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
    }
    .title {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 40px;
        font-style: normal;
        font-weight: 600;
        line-height: 44px; /* 110% */
        position: relative;
    }

    .description{
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 150% */
    }
    .button {
        display: flex;
        padding: 20px 32px;
        justify-content: center;
        align-items: center;
        border-radius: 100px;
        border: 1px solid var(--gray-40-button-stroke, #D1D6DB);
        background: #1D4A94;
        color: var(--Gray-00, #FFF);
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px; /* 100% */
        cursor: pointer;
    }
    .text2 {
        color: var(--Blue-01_Primary-blue, #008DEF);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px; /* 125% */
    }
    .text3 {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px; /* 125% */
    }
    .button2 {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 172px;
        height: 50px;
        border-radius: 6px;
        background: #1D4A94;
        color: var(--Gray-00, #FFF);
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 90% */
        cursor: pointer;
    }
    .fixed-bar {
        display: flex;
        position: fixed;
        top: 72px;
        left: 0;
        width: 100%;
        height: 72px;
        box-sizing: border-box;
        justify-content: center;
        align-items: center;
        border: 1px solid var(--gray-40-button-stroke, #D1D6DB);
        background: var(--Gray-20, #F3F5F8);
    }
    .info-text {
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    .image {
        position: absolute;
        width: 67px;
        top: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/organisms/pc_uncomfortable/RankingBanner.vue